import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import InputItem from './inputItem';

class AddressForm extends Component {
  constructor(props) {
    super(props);
    this.onDataChange = this.onDataChange.bind(this);
    this.state = { open: false, data: this.props.data }
    this.original = JSON.parse(JSON.stringify(this.props.data))
  }

  onCloseModal = () => {
    this.setState({ data: JSON.parse(JSON.stringify(this.original)), open: false });    
};

  onDataChange(evt) {
    
    const id = evt.target.id
    const val = evt.target.value

    let state = this.state;
    state.data[id] = val;

    this.setState(state);
    
  }
  
  componentDidUpdate(prevProps) {
    if(prevProps.data !== this.props.data) {
        this.setState({data: this.props.data});
    }
}
  render() {
    var { data } = this.state;
    if (!data.street) data.street = "";
    if (!data.city) data.city = "";
    if (!data.state) data.state = "";
    if (!data.postalCode) data.postalCode = "";
    if (!data.country) data.country = "";
    
    return (
      <div className="box">
        <div className="box-title">
          <h3>{this.props.title} &nbsp;&nbsp;<button className="badge badge-info" onClick={() => {this.setState({open: true})}}>Edit Address</button></h3>
        </div>
        <div className="box-content">
          <address>
            {data.street ?
            <p>
              {`${data.street}`}
              <br/>{`${data.city}, ${data.state} ${data.postalCode}`}
              <br/>{`${data.country}`}
            </p>
            :
            <p>No Address Set</p>
            }
          </address>
          <Modal open={this.state.open} onClose={this.onCloseModal} >
            <div className="modal-header">
              <h5 className="modal-title f-w-600" id="exampleModalLabel2">Update Address</h5>
            </div>
            <div className="modal-body">
              <div className="container">
                <div className="card">
                  <div className="card-body">
                    <InputItem label="Street" id="street" value={data.street} onChange={this.onDataChange} placeholder="" />
                    <InputItem label="City" id="city" value={data.city} onChange={this.onDataChange} placeholder="" />
                    <InputItem label="State" id="state" value={data.state} onChange={this.onDataChange} placeholder="" />
                    <InputItem label="Zip Code" id="postalCode" value={data.postalCode} onChange={this.onDataChange} placeholder="" />
                    <InputItem label="Country" id="country" value={data.country} onChange={this.onDataChange} placeholder="" />
                  </div>
                </div>        
              </div>
            </div>
            <div className="modal-footer">              
              <button type="button" className="btn btn-secondary" onClick={this.onCloseModal}>Cancel</button>
              <button type="button" className="btn btn-primary" onClick={() => { this.setState({open: false}); this.props.onCloseModal('address', this.state.data)}}>Approve</button>
            </div>
          </Modal>
        </div>
      </div>

      );
  }
}

export default AddressForm;